import { FileRejection } from "@mantine/dropzone";
import React from "react";
import Dropzone from "@/components/admin/Dropzone";
import { ONE_VOC_FILE_MAX_SIZE } from "@/configs/constants/app/voc-data-management";
import classes from "./FileDropzoneButton.module.css";

interface FileDropzoneButtonProps {
  onAcceptedFiles: (files: File[]) => void;
  onRejectedFiles: (files: FileRejection[]) => void;
  maxFiles: number;
}
export const FileDropzoneButton: React.FC<FileDropzoneButtonProps> = ({
  onAcceptedFiles,
  onRejectedFiles,
  maxFiles,
}) => {
  function handleReject(fileRejections: FileRejection[]) {
    onRejectedFiles(fileRejections);
  }

  return (
    <div className={classes.wrapper}>
      <Dropzone
        title="VoCデータアップロード"
        acceptableMimeTypes={["csv", "xlsx"]}
        maxSize={ONE_VOC_FILE_MAX_SIZE}
        multiple={true}
        maxFiles={maxFiles}
        onDrop={onAcceptedFiles}
        onReject={handleReject}
      />
    </div>
  );
};
